import { render, staticRenderFns } from "./SendMessageForm.vue?vue&type=template&id=5b7372de&scoped=true"
import script from "./SendMessageForm.vue?vue&type=script&lang=js"
export * from "./SendMessageForm.vue?vue&type=script&lang=js"
import style0 from "./SendMessageForm.vue?vue&type=style&index=0&id=5b7372de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7372de",
  null
  
)

export default component.exports